import { createSlice } from '@reduxjs/toolkit';

import { AuthLogin } from './types';

const initialState: AuthLogin = {
    empid: null,
    mgrEmpid: null,
    user: null,
    userEmail: null,
    role: null,
    userManagerLevel: null,
    isAdmin: null,
    isEds: null,
    token: null,
    refreshToken: null,
    expiresIn: null,
    impEmpid: null,
    impMgrEmpid: null,
    impUser: null,
    impUserEmail: null,
    impRole: null,
    impUserManagerLevel: null,
    impIsAdmin: null,
    impIsEds: null,
    isUserImpersonate: null,
    isDelegate: null,
    isComp: null,
    impIsComp: null,
    userFullName: null,
    isHC: null,
    impIsHC: null,
    caTabSelection: null,
    actualLoggedIn: null,
    userCount: null,
    isPseudoSupervisor: null,
    metricChartHandleSave: null,
    isAllowCoachingInsight: null,
    isAllowCoachingActionModel: null,
    isUserinPercepta: null,
    isUserMoodMeterHidden: null,
    userNameWithId: null,
    chatAgtId: null,
    userParentClient: null,
    isManagerRecentApprover: null,
};

const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        setCredentials: (state, action) => {
            const {
                empid,
                mgrEmpid,
                user,
                email,
                role,
                userManagerLevel,
                isAdmin,
                isEds,
                isComp,
                userFullName,
                isDelegate,
                isHC,
                userNameWithId,
            } = action.payload;
            state.empid = empid;
            state.mgrEmpid = mgrEmpid;
            state.user = user;
            state.userEmail = email;
            state.role = role;
            state.userManagerLevel = userManagerLevel;
            state.isAdmin = isAdmin;
            state.isEds = isEds;
            state.isComp = isComp;
            state.userFullName = userFullName;
            state.isDelegate = isDelegate;
            state.isHC = isHC;
            state.userNameWithId = userNameWithId;
        },
        logOut: (state) => {
            state.empid = null;
            state.mgrEmpid = null;
            state.user = null;
            state.userEmail = null;
            state.role = null;
            state.token = null;
            state.userManagerLevel = null;
            state.isAdmin = null;
            state.isEds = null;
            state.isComp = null;
            state.refreshToken = null;
            state.impEmpid = null;
            state.impUser = null;
            state.impRole = null;
            state.impUserManagerLevel = null;
            state.impIsAdmin = null;
            state.impIsEds = null;
            state.impIsComp = null;
            state.isUserImpersonate = null;
            state.isDelegate = null;
            state.userFullName = null;
            state.isHC = null;
            state.impIsHC = null;
            state.caTabSelection = null;
            state.isPseudoSupervisor = null;
            state.metricChartHandleSave = null;
            state.isAllowCoachingInsight = null;
            state.isAllowCoachingActionModel = null;
            state.isUserinPercepta = null;
            state.chatAgtId = null;
            state.userParentClient = null;
            state.isManagerRecentApprover = null;
        },
        setAuthCredentials: (state, action) => {
            const { token, refreshToken, expiresIn } = action.payload;

            state.token = token;
            state.refreshToken = refreshToken;
            state.expiresIn = expiresIn;
        },
        setImpersonateCredentials: (state, action) => {
            const {
                empid,
                mgrEmpid,
                user,
                email,
                role,
                userManagerLevel,
                isAdmin,
                isEds,
                isComp,
                isUserImpersonate,
                userFullName,
                isHC,
            } = action.payload;
            state.impEmpid = empid;
            state.impMgrEmpid = mgrEmpid;
            state.impUser = user;
            state.impUserEmail = email;
            state.impRole = role;
            state.impUserManagerLevel = userManagerLevel;
            state.impIsAdmin = isAdmin;
            state.impIsEds = isEds;
            state.impIsComp = isComp;
            state.isUserImpersonate = isUserImpersonate;
            state.userFullName = userFullName;
            state.impIsHC = isHC;
        },
        setCaTabSelection: (state, action) => {
            state.caTabSelection = action.payload;
        },
        setActualLoggedIn: (state, action) => {
            state.actualLoggedIn = action.payload;
        },
        setUserActiveCount: (state, action) => {
            state.userCount = action.payload;
        },
        setIsPseudoSupervisor: (state, action) => {
            state.isPseudoSupervisor = action.payload;
        },
        setMetricChartHandleSave: (state, action) => {
            state.metricChartHandleSave = action.payload;
        },
        setIsAllowCoachingInsight: (state, action) => {
            state.isAllowCoachingInsight = action.payload;
        },
        setIsAllowCoachingActionModel: (state, action) => {
            state.isAllowCoachingActionModel = action.payload;
        },
        setIsUserinPercepta: (state, action) => {
            state.isUserinPercepta = action.payload;
        },
        setIsUserMoodMeterHidden: (state, action) => {
            state.isUserMoodMeterHidden = action.payload;
        },
        setIsUseCoachingSkills: (state, action) => {
            state.isUseCoachingSkills = action.payload;
        },
        setMgrEmpId: (state, action) => {
            state.mgrEmpid = action.payload;
        },
        setChatAgtId: (state, action) => {
            state.chatAgtId = action.payload;
        },
        setUserParentClient: (state, action) => {
            state.userParentClient = action.payload;
        },
        setIsManagerRecentApprover:(state,action)=>{state.isManagerRecentApprover = action.payload;}
    },
});

export const {
    setCredentials,
    logOut,
    setUserActiveCount,
    setAuthCredentials,
    setImpersonateCredentials,
    setCaTabSelection,
    setActualLoggedIn,
    setIsPseudoSupervisor,
    setMetricChartHandleSave,
    setIsAllowCoachingInsight,
    setIsAllowCoachingActionModel,
    setIsUserinPercepta,
    setIsUserMoodMeterHidden,
    setIsUseCoachingSkills,
    setMgrEmpId,
    setChatAgtId,
    setUserParentClient,
     setIsManagerRecentApprover
} = authSlice.actions;

export default authSlice.reducer;

export const selectCurrentEmpid = (state: any) => state.auth.empid;
export const selectCurrentMgrEmpid = (state: any) => state.auth.mgrEmpid;
export const selectCurrentUser = (state: any) => state.auth.user;
export const selectCurrentUserEmail = (state: any) => state.auth.userEmail;
export const selectCurrentRole = (state: any) => state.auth.role;
export const selectCurrentUserManagerLevel = (state: any) => state.auth.userManagerLevel;
export const selectCurrentIsAdmin = (state: any) => state.auth.isAdmin;
export const selectCurrentIsManagerOrAdmin = (state: any) => state.auth.isManagerOrAdmin;
export const selectCurrentIsEds = (state: any) => state.auth.isEds;
export const selectCurrentToken = (state: any) => state.auth.token;
export const selectRefreshToken = (state: any) => state.auth.refreshToken;
export const selectCurrentisComp = (state: any) => state.auth.isComp;
export const selectCurrentUserFullName = (state: any) => state.auth.userFullName;
export const selectCurrentIsHC = (state: any) => state.auth.isHC;
export const selectCurrentUserNameWithId = (state: any) => state.auth.userNameWithId;
export const selectCurrentChatAgtId = (state: any) => state.auth.chatAgtId;
export const selectCurrentUserParentClient = (state: any) => state.auth.userParentClient;

// Impersonate
export const selectImpEmpid = (state: any) => state.auth.impEmpid;
export const selectImpUser = (state: any) => state.auth.impUser;
export const selectImpUserEmail = (state: any) => state.auth.impUserEmail;
export const selectImpRole = (state: any) => state.auth.impRole;
export const selectImpUserManagerLevel = (state: any) => state.auth.impUserManagerLevel;
export const selectImpIsAdmin = (state: any) => state.auth.impIsAdmin;
export const selectImpIsEds = (state: any) => state.auth.impIsEds;
export const selectImpIsComp = (state: any) => state.auth.impIsComp;
export const selectIsUserImpersonate = (state: any) => state.auth.isUserImpersonate;
export const selectIsDelegate = (state: any) => state.auth.isDelegate;
export const selectIsuserFullNameImpersonate = (state: any) => state.auth.userFullName;
export const selectImpIsHC = (state: any) => state.auth.impIsHC;

//CaTabSelection
export const selectCaTabSelection = (state: any) => state.auth.caTabSelection;
export const selectActualLoggedIn = (state: any) => state.auth.actualLoggedIn;
export const selectedUserCount = (state: any) => state.auth.userCount;
export const selectIsPseudoSupervisor = (state: any) => state.auth.isPseudoSupervisor;

// Metric Chart
export const selectMetricChartHandleSave = (state: any) => state.auth.metricChartHandleSave;

// Coaching Insight Access Control
export const selectIsAllowCoachingInsight = (state: any) => state.auth.isAllowCoachingInsight;
export const selectIsAllowCoachingActionModel = (state: any) => state.auth.isAllowCoachingActionModel;
export const selectIsUserinPercepta = (state: any) => state.auth.isUserinPercepta;
export const selectIsUserMoodMeterHidden = (state: any) => state.auth.isUserMoodMeterHidden;
export const selectIsUseCoachingSkills = (state: any) => state.auth.isUseCoachingSkills;

export const selectIsManagerRecentApprover = (state: any) => state.auth.isManagerRecentApprover;